module.exports = __webpack_public_path__ + "534dbd8ffbad812274a10d64218e2bb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/milestoneImage/background-blue.svg
// module id = ./src/helpers/images/milestoneImage/background-blue.svg
// module chunks = 4